import {
    ShoppingBag,
    Handshake,
    Ear,
    Banknote,
    Monitor,
    MessageSquareQuote,
    ShoppingCart,
    Megaphone,
    Receipt,
    CarFront,
    BarChart3,
    Building2,
    ScanQrCode,
    SquareArrowOutUpRight,
    Scale,
    Sparkles,
    ListChecks,
    Wallet,
    GraduationCap,
    Clock4,
    Code,
    Lightbulb,
    Globe2,
    Truck,
    Users,
    Tag,
    UserCheck,
    ClipboardList,
    Folder,
    ShieldCheck,
    UserPlus,
    HardDrive,
    BookOpen,
    Book,
    Zap,
    BatteryCharging,
    Volume2,
} from 'lucide-react';
import {
    MessageSquare,
    Calculator,
    RefreshCcw,
    Briefcase,
    Cpu,
    Crown,
    Gavel,
    Heart,
    Rocket,
    Clock,
    Code2,
    Globe,
    FileSpreadsheet,
    Factory,
    FolderKanban,
    Headphones,
    Leaf,
    Building,
    Brain,
    Laptop,
    Languages,
    BarChart,
    FileText,
    Database,
    Mic
} from "lucide-react";


export const getThemeIcon = (theme) => {
    // Si theme est null, undefined ou falsy, retourner l'icône par défaut
    if (!theme) {
        return { icon: BookOpen, color: 'text-gray-600', bg: 'bg-gray-100' };
    }
    const iconMap = {
        'Achats': { icon: ShoppingBag, color: 'text-purple-700', bg: 'bg-purple-100' },
        'Assistant(e)': { icon: Handshake, color: 'text-pink-700', bg: 'bg-pink-100' },
        'Audit - Organisation - Conseil': { icon: Ear, color: 'text-amber-700', bg: 'bg-amber-100' },
        'Banque': { icon: Banknote, color: 'text-teal-700', bg: 'bg-teal-100' },
        'Bureautique - PAO': { icon: Monitor, color: 'text-indigo-700', bg: 'bg-indigo-100' },
        'Coaching': { icon: MessageSquareQuote, color: 'text-violet-700', bg: 'bg-violet-100' },
        'Commercial - Vente': { icon: Handshake, color: 'text-orange-700', bg: 'bg-orange-100' },
        'Communication': { icon: MessageSquare, color: 'text-rose-700', bg: 'bg-rose-100' },
        'Comptabilité - Fiscalité': { icon: Calculator, color: 'text-cyan-700', bg: 'bg-cyan-100' },
        'Conduite du changement': { icon: RefreshCcw, color: 'text-yellow-700', bg: 'bg-yellow-100' },
        'Contrôle de gestion': { icon: BarChart3, color: 'text-sky-700', bg: 'bg-sky-100' },
        "Création d'entreprise": { icon: Briefcase, color: 'text-fuchsia-700', bg: 'bg-fuchsia-100' },
        'Digital': { icon: Cpu, color: 'text-blue-700', bg: 'bg-blue-100' },
        'Direction': { icon: Crown, color: 'text-gray-800', bg: 'bg-gray-200' },
        'Droit': { icon: Scale, color: 'text-red-700', bg: 'bg-red-100' },
        'Droit des affaires': { icon: Gavel, color: 'text-red-700', bg: 'bg-red-100' },
        'Developpement personnel': { icon: Heart, color: 'text-green-700', bg: 'bg-green-100' },
        'Efficacité professionnelle': { icon: Rocket, color: 'text-emerald-700', bg: 'bg-emerald-100' },
        'Finance - Trésorerie': { icon: Wallet, color: 'text-lime-700', bg: 'bg-lime-100' },
        'Formation': { icon: GraduationCap, color: 'text-indigo-700', bg: 'bg-indigo-100' },
        'Gestion du temps': { icon: Clock, color: 'text-yellow-700', bg: 'bg-yellow-100' },
        'Immo & Services généraux': { icon: Building2, color: 'text-stone-700', bg: 'bg-stone-100' },
        'Informatique - SI': { icon: Code2, color: 'text-blue-800', bg: 'bg-blue-100' },
        'Innovation - Créativité': { icon: Lightbulb, color: 'text-fuchsia-700', bg: 'bg-fuchsia-100' },
        'International': { icon: Globe, color: 'text-cyan-700', bg: 'bg-cyan-100' },
        'Logistique': { icon: Truck, color: 'text-teal-700', bg: 'bg-teal-100' },
        'Management': { icon: Users, color: 'text-purple-700', bg: 'bg-purple-100' },
        'Marketing': { icon: Megaphone, color: 'text-pink-700', bg: 'bg-pink-100' },
        'Organisation - Audit': { icon: ClipboardList, color: 'text-amber-700', bg: 'bg-amber-100' },
        'Paie/Admin du personnel': { icon: FileSpreadsheet, color: 'text-indigo-700', bg: 'bg-indigo-100' },
        'Production': { icon: Factory, color: 'text-yellow-700', bg: 'bg-yellow-100' },
        'Projet': { icon: FolderKanban, color: 'text-sky-700', bg: 'bg-sky-100' },
        'Qualité-Santé-Sécurité-Environnement': { icon: ShieldCheck, color: 'text-green-700', bg: 'bg-green-100' },
        'Relation client': { icon: Headphones, color: 'text-orange-700', bg: 'bg-orange-100' },
        'Ressources Humaines': { icon: Users, color: 'text-indigo-700', bg: 'bg-indigo-100' },
        'Développement durable': { icon: Leaf, color: 'text-emerald-700', bg: 'bg-emerald-100' },
        'Secteur public': { icon: Building, color: 'text-gray-700', bg: 'bg-gray-100' },
        'Soft skills': { icon: Brain, color: 'text-pink-700', bg: 'bg-pink-100' },
        "Travail à distance": { icon: Laptop, color: 'text-pink-700', bg: 'bg-pink-100' },
        'Télétravail (freelance)': { icon: Book, color: 'text-cyan-700', bg: 'bg-cyan-100' },
        'Langue': { icon: Languages, color: 'text-indigo-700', bg: 'bg-indigo-100' },
        'Bureautique Microsoft Excel': { icon: FileSpreadsheet, color: 'text-green-700', bg: 'bg-green-100' },
        'Bureautique Microsoft Power BI': { icon: BarChart, color: 'text-yellow-700', bg: 'bg-yellow-100' },
        'Bureautique Microsoft Powerpoint': { icon: Presentation, color: 'text-red-700', bg: 'bg-red-100' },
        'Bureautique Microsoft Word': { icon: FileText, color: 'text-blue-700', bg: 'bg-blue-100' },
        'Bureautique Microsoft Access': { icon: Database, color: 'text-purple-700', bg: 'bg-purple-100' },
        'Art Oratoire': { icon: Mic, color: 'text-rose-700', bg: 'bg-rose-100' },
        'Energie et Electricité': { icon: BatteryCharging, color: 'text-yellow-700', bg: 'bg-yellow-100' },
    };

    return iconMap[theme] || { icon: BookOpen, color: 'text-gray-600', bg: 'bg-gray-100' };
};
